import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppChecklist = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "checklist",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3649_17431",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3649_17431)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "checklist_2",
				d: "M5.55 18.9998L2 15.4498L3.4 14.0498L5.525 16.1748L9.775 11.9248L11.175 13.3498L5.55 18.9998ZM5.55 10.9998L2 7.4498L3.4 6.0498L5.525 8.1748L9.775 3.9248L11.175 5.3498L5.55 10.9998ZM13 16.9998V14.9998H22V16.9998H13ZM13 8.9998V6.9998H22V8.9998H13Z",
				fill: "white"
			})
		})]
	})
});
export default SvgAppChecklist;
